import { useStore } from '../../state/createStore';
import { localeStore } from '../../i18n/i18n';
import { RemoteSignPage } from './RemoteSignPage';

// The whole app for a client who opened a signing link: one page, in the chosen language, nothing else
// (no shell, no navigation, no account).
export function RemoteSignRoot(props: { token: string }) {
  const locale = useStore(localeStore, (s) => s.locale);
  return (
    <div className="app-shell remote-shell" lang={locale} data-locale={locale}>
      <RemoteSignPage token={props.token} />
    </div>
  );
}
